import makeRequest from '../../../../common/utils/makeRequest';
import { getMultipartSignedUrlsQuery } from '../queries';

async function getPartSignedUrls(
apiClient,
uploadId,
bucketKey,
organisationId,
parts)
{
  const requestParams = {
    query: getMultipartSignedUrlsQuery,
    variables: {
      bucketKey,
      uploadId,
      organisationId,
      parts
    },
    context: { module: 'upload' },
    fetchPolicy: 'network-only'
  };
  const { data, error } = await makeRequest({
    request: apiClient.query,
    requestParams
  });

  if (!data || !data.getMultipartSignedUrls || error) {return null;}

  return data.getMultipartSignedUrls;
}

export default getPartSignedUrls;